<template>
    <div class="currency-view">
        <div class="ratesheader flex justify-between items-center">
            <div></div>
            <h1>Currency Overview</h1>
            <div class="fetch-container flex items-center gap-10">
                <input type="date" v-model="startDate" />
                <button class="button w-content" @click="loadRates()">Fetch rates</button>
            </div>
        </div>
        <select v-model="item" class="currency-select">
            <option v-for="(data, pair) in rateData" :key="pair" :value="pair">{{ pair }}</option>
        </select>
        <div class="rates" v-if="Object.keys(rateData).length > 0">
            <CalendarView :name="item" :key="item" :data="rateData[item]" @dayClicked="setDate"/>
        </div>
        <button class="button w-content" @click="() => showPriveChart = !showPriveChart"> Show/Hide Prive Chart</button>
        <div class="chart-container" v-if="showPriveChart && item && Object.keys(rateData).length > 0" >
            <apexchart 
                class="chart-element" 
                type="line" 
                height="400px"
                :options="getChartOptions()"
                :series="[{
                    name: item,
                    data: Object.values(rateData[item])
                }]"
            ></apexchart>
        </div>
    </div>
</template>

<script setup>
    import { onMounted, ref } from 'vue';
    import BO_API from '../api/bo_api.js'
    import CalendarView from './CalendarView.vue';
    import store from '../store/index.js';
    const rateData = ref({});
    const item = ref('USD_EUR')
    const startDate = ref(null)
    const showPriveChart = ref(false)

    function getChartOptions(){
        return {
            chart: {
                type: 'line',
                width: '100%',
                height: '100%',
                parentHeightOffset: 0
            },
            toolbar: {
                show: false
            },
            animations: {
                enabled: false
            },
            title: {
                text: 'Currency Rates Over Time'
            },
            xaxis: {
                categories: Object.keys(rateData.value[item.value] || {}).sort()
            },
            yaxis: {
                title: {
                    text: 'Exchange Rate'
                }
            },
        }
    }   
    function setDate(data) {
        console.log('setting date', data)
        startDate.value = data
    }
    async function loadRates() {
        const response = await BO_API.fetchRates(startDate.value);
        console.log('Fetched rates:', response);
        store.dispatch('addNotification', { type: 'success', text: response.message });
    }
    onMounted(async () => {
        // Example: Fetch currencies when the component is mounted
        const data = await BO_API.getRates()
        const currencyPairs = {};
        
        
        for (let key in data.rates) {
            const [from, to, date] = key.split('_');
            const pair = `${from}_${to}`;

            if (!rateData.value[pair]) {
                console.log('creating pair', pair)
                rateData.value[pair] = {};
            }
            rateData.value[pair][date.slice(0, 10)] = data.rates[key];
        }
        console.log('rateData', rateData.value['USD_AED'])
    })

</script>

<style scoped lang="scss">
   .chart-element {
        width: 100%;
        height: 100%;
    }
   .chart-container {
        height: 400px;
        max-height: 400px;
        width: 100%;
    }
    .chart-container .chart-element {
        height: 400px !important;
    }
    .currency-view {
        padding: 20px
    }
</style>